export const PLACED_AN_ORDER = 'placed_an_order';
